import SessionChildren from "./candidatSession/candidatSessionChildren";
import CandidatProfileChildren from "./candidatSession/candidatProfileChildren";

const Questionnaire = () =>
  import(
    /* webpackChunkName: "Rest" */ "@/components/certipers-candidat/session/Questionnaire.vue"
  );

const CandidatDashboard = () =>
  import(/* webpackChunkName: "Rest" */ "@/components/certipers-candidat/CandidatDashboard.vue");

const CandidatSessions = () =>
  import(/* webpackChunkName: "Rest" */ "@/components/certipers-candidat/CandidatSessions.vue");

const CandidatCycles = () =>
  import(/* webpackChunkName: "Rest" */ "@/components/certipers-candidat/CandidatCycles.vue");

const Profile = () =>
  import(/* webpackChunkName: "Rest" */ "@/components/certipers-candidat/Profile.vue");
const SessionResume = () =>
  import(
    /* webpackChunkName: "SessionStart" */ "@/components/certipers-candidat/session/SessionResume.vue"
  );

export default [
  {
    path: "",
    redirect: { name: "candidate-dashboard" },
  },
  {
    path: "session/:userSessionUuid?/resume",
    name: "candidate-session-resume",
    component: SessionResume,
  },
  {
    path: "exam/:userSessionId?/questionnaire/:questionnaireSessionId?/question/:questionId?",
    name: "candidate-questionnaire",
    component: Questionnaire,
  },
  {
    path: "dashboard",
    name: "candidate-dashboard",
    component: CandidatDashboard,
  },
  {
    path: "sessions",
    name: "candidate-sessions",
    children: SessionChildren,
    component: CandidatSessions,
  },
  {
    path: "cycles",
    name: "candidate-cycles",
    component: CandidatCycles,
  },
  {
    path: "profile",
    name: "candidate-profile",
    children: CandidatProfileChildren,
    component: Profile,
  },
];
